<template>
  <div>
    <div class="view-header">
      <h1 class="is-size-5 is-expanded">Users</h1>
      <router-link
        to="/user/add"
        class="button is-primary is-small is-uppercase"
        v-if="role === 'admin'"
      >Add</router-link>
    </div>
    <div class="box" style="margin-top: 12px;">
      <component-search></component-search>
      <component-filters></component-filters>
    </div>
    <user-table class="is-hidden-mobile"></user-table>
    <user-list class="is-hidden-tablet"></user-list>
    <app-paginate module="user"></app-paginate>
  </div>
</template>
<script>
import ComponentSearch from "./components/search";
import ComponentFilters from "./components/filters";
import UserTable from "./components/user-table";
import UserList from "./components/user-list";
export default {
  components: {
    ComponentSearch,
    ComponentFilters,
    UserTable,
    UserList
  },
  computed: {
    role() {
      return localStorage.getItem("role");
    }
  },
  mounted() {
    let component = this;
    component.$store.commit("user/page", 1);
    component.$store.commit("user/limit", 10);
    component.$store.commit("user/role", "all");
    component.$store.commit("user/docs", []);
    component.$store.commit("user/totalDocs", 0);
    component.$store.commit("user/totalPages", 0);
    component.$store.dispatch("user/index");
  }
};
</script>
<style lang="scss" scoped>
.is-flex {
  .view-title {
    flex-basis: 0;
    flex-grow: 1;
  }
  .add-button {
    margin-top: 12px;
  }
}
</style>